import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Popup from "./BasePopup";
import moment from "moment";
import { editUserInGameName, getUserInGameName } from "../../api/userInGameName.api";
import TextInput from "../CommonFields/TextInput";
import DateTimePopup from "./DateTimePopup";
import { generateArrayOfYears, generateMonths, generateNumberArray } from "./Utils";
import { toastError } from "../../Utilities/toast";
import { userUpdateProfile } from "../../api/auth.api";
import { useProfileDataContext } from "../ProfileContext/ProfileContext";

const JoiningScrimPopup = ({ isOpen, title, onClose, setingameName, contest, onJoinContest, isDisableJoinBtn, setIsDisableJoinBtn }) => {
  const { t } = useTranslation();
  const [uniqueIgn, setUniqueIgn] = useState(null);
  const [userReadOnly, setUserReadOnly] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState(null); // State to store the selected date
  const [dateOfBirthDB, setDateOfBirthDB] = useState("");
  const [isDateTimePopup, setDateTimePopup] = useState(false);
  const [inGameName, setinGameName] = useState("");
  const { fetchAccountProfile, liteProfile } = useProfileDataContext();

  const handleOpenPopup = () => {
    setDateTimePopup(true);
  };
  useEffect(() => {
    fetchInGameName();
  },[])
  const handleDateSave = (formattedDate) => {
    const [day, month, year] = formattedDate.split("/");
    const paddedDay = day.padStart(2, '0'); // Add leading zero if needed
    const paddedMonth = month.padStart(2, '0'); // Add leading zero if needed
    const formatted = `${paddedDay}-${paddedMonth}-${year}`; // Convert to "dd-mm-yyyy"
    setDateOfBirth(formatted); // Update state with the selected date
    setDateOfBirthDB(`${year}-${paddedMonth}-${paddedDay}`); // Update state with the selected date
    setDateTimePopup(false); // Close the popup
  };
  const toggleDateTimePopup = () => {
    setDateTimePopup(prevState => !prevState);
  };
  const handleSave = async () => {
    setIsDisableJoinBtn(true);
    let error = false;
    if (!JSON?.parse(localStorage?.getItem('profile'))?.dateOfBirth && !dateOfBirthDB) {
      error = true;
      toastError(t('errors.error_please_select_date_of_birth'));
    }
    else if (!inGameName?.trim()) {
      error = true;
      toastError(t('validations.please_enter_user_in_game_name'));
    }

    if (!error) {
      if (inGameName?.trim() && inGameName?.trim() !== uniqueIgn?.trim()) {
        let profileLiteDate = JSON.parse(localStorage.getItem('profileLite'))
        let activeGameId = localStorage.getItem('activeGameId')
        let payload = {};
        payload = {
          game: activeGameId,
          user: profileLiteDate?.user_id,
          userINGameName: inGameName?.trim()
        };
        const res = await editUserInGameName(payload);
        if (res?.success) {
          setUniqueIgn(inGameName?.trim())
          let payload = {
            game: activeGameId,
            user: profileLiteDate?.user_id,
          }
          fetchInGameName(payload)
        } else {
          setUniqueIgn(null)
        }
      }
      if (!JSON?.parse(localStorage?.getItem('profile'))?.dateOfBirth && dateOfBirthDB) {
        let payloadProfile = {
          dateOfBirth: new Date(dateOfBirthDB)
        };
        const resProfile = await userUpdateProfile(payloadProfile);
        if (resProfile?.success) {
          fetchAccountProfile()
        }
      }
    }
    onJoinContest()
  };
  const fetchInGameName = async () => {
    try {
      let profileLiteDate = JSON.parse(localStorage.getItem('profileLite'))
      let activeGameId = localStorage.getItem('activeGameId')
      let payload = {
        game: activeGameId,
        user: profileLiteDate?.user_id
      }
      const res = await getUserInGameName(payload);
      if (res?.success && res?.data) {
        setUniqueIgn(res?.data.userINGameName)
        setinGameName(res?.data.userINGameName)
        setingameName(res?.data.userINGameName)
        setUserReadOnly(true)
      }
      else {
        setUniqueIgn(null)
        setinGameName(null)
        setUserReadOnly(false)
      }
    } catch (error) { setUserReadOnly(false) }
  };
  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose} marqueeTitle={title?.length>18 ? true:false }>
      <div className="tournament-joining-popup-wrapper">
        <div className="tournament-joining-popup-inner-wrapper">
          <div className="tournament-joining-popup-step1">
            <div className="tournament-joining-popup-gameinfo">
              {contest?.gameAry[0]?.name} - {contest?.gameTypeAry?.name}{" "}
            </div>
          </div>
          <div className="tournament-joining-popup-wrapper">
          <div className="tournament-joining-popup-inner-wrapper">
          
            <div className="tournament-joining-popup-step2 mt-4">
              <>
                {!JSON?.parse(localStorage?.getItem('profile'))?.dateOfBirth &&
                  <div className="tournament-joining-popup-dateofbirth">
                    <div className="datepicker-input--wrap">
                      <TextInput
                        labelName={t('profile.date_of_birth')}
                        placeholder={"dd/mm/yyyy"}
                        value={dateOfBirth}
                        onChange={(e) => e.preventDefault()} // Prevent manual changes
                        readOnly // Make the input read-only
                        onClick={handleOpenPopup} // Open popup on click
                      />
                    </div>
                    <div className="datepicker-icon" onClick={toggleDateTimePopup}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2737_8465)">
                          <path d="M17.66 1.56H16.72V0H15.16V1.56H4.84V0H3.28V1.56H2.34C1.05 1.56 0 2.61 0 3.91V17.66C0 18.95 1.05 20 2.34 20H17.65C18.94 20 19.99 18.95 19.99 17.66V3.91C19.99 2.62 18.94 1.57 17.65 1.57L17.66 1.56ZM18.44 17.66C18.44 18.09 18.09 18.44 17.66 18.44H2.34C1.91 18.44 1.56 18.09 1.56 17.66V7.34H18.44V17.65V17.66ZM18.44 5.78H1.56V3.9C1.56 3.47 1.91 3.12 2.34 3.12H3.28V4.68H4.84V3.12H15.15V4.68H16.71V3.12H17.65C18.08 3.12 18.43 3.47 18.43 3.9V5.78H18.44Z" fill="white" />
                          <path d="M4.53 8.98H2.97V10.54H4.53V8.98Z" fill="white" />
                          <path d="M7.65 8.98H6.09V10.54H7.65V8.98Z" fill="white" />
                          <path d="M10.78 8.98H9.22V10.54H10.78V8.98Z" fill="white" />
                          <path d="M13.9 8.98H12.34V10.54H13.9V8.98Z" fill="white" />
                          <path d="M17.03 8.98H15.47V10.54H17.03V8.98Z" fill="white" />
                          <path d="M4.53 12.11H2.97V13.67H4.53V12.11Z" fill="white" />
                          <path d="M7.65 12.11H6.09V13.67H7.65V12.11Z" fill="white" />
                          <path d="M10.78 12.11H9.22V13.67H10.78V12.11Z" fill="white" />
                          <path d="M13.9 12.11H12.34V13.67H13.9V12.11Z" fill="white" />
                          <path d="M4.53 15.23H2.97V16.79H4.53V15.23Z" fill="white" />
                          <path d="M7.65 15.23H6.09V16.79H7.65V15.23Z" fill="white" />
                          <path d="M10.78 15.23H9.22V16.79H10.78V15.23Z" fill="white" />
                          <path d="M13.9 15.23H12.34V16.79H13.9V15.23Z" fill="white" />
                          <path d="M17.03 12.11H15.47V13.67H17.03V12.11Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2737_8465">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                    </div>
                  </div>
                }

                <></>
                {isDateTimePopup && (
                  <DateTimePopup
                    isOpen={isDateTimePopup}
                    title={t("validations.select_date")}
                    onClose={() => setDateTimePopup(false)}
                    onSave={handleDateSave} // Pass handleSaveDate to DateTimePopup
                    dayOptions={generateNumberArray(1, 8, 2024)}
                    monthOptions={generateMonths()}
                    yearOptions={generateArrayOfYears()}
                  />
                )}

                {/* BIRTHDAY  Upate Input Block */}
                {/* InGameNamePopUP */}
                {/* <div className="tournament-joining-popup-ingamename">
                  <TextInput
                    labelName={t("user_in_game_name.game_user_name", { gameName: contest?.gameAry[0]?.name?.toLowerCase() })}
                    placeholder={t("errors.error_enter_user_in_game_name", { gameName: contest?.gameAry[0]?.name?.toLowerCase() })}
                    value={inGameName}
                    inputLength="32"
                    onChange={(e) => {
                      setinGameName(e.target.value?.trim());
                      setingameName(e.target.value?.trim());
                    }}
                  />
                </div> */}
                <div className="tournament-joining-popup-ingamename tournament-space-bottom-popup">
                  <div className="input-with-icon">
                    <TextInput
                      labelName={t("user_in_game_name.game_user_name", { gameName: contest?.gameAry[0]?.name?.toLowerCase() })}
                      placeholder={t("errors.error_enter_user_in_game_name", { gameName: contest?.gameAry[0]?.name?.toLowerCase() })}
                      value={inGameName}
                      inputLength="32"
                      onChange={(e) => {
                        setinGameName(e.target.value?.trim())
                        setingameName(e.target.value?.trim())
                      }}
                      readOnly={inGameName ? userReadOnly : false}
                    />
                    {(inGameName && userReadOnly) &&
                      <span className="edit-icon" onClick={() => {
                        setUserReadOnly(false);
                      }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                          <path d="M15.8061 15.873V7.07183C15.7985 6.95464 15.7497 6.84489 15.6694 6.76476C15.5892 6.68462 15.4836 6.64005 15.3738 6.64005C15.2641 6.64005 15.1585 6.68462 15.0782 6.76476C14.998 6.84489 14.9491 6.95464 14.9415 7.07183V15.873C14.9413 16.0107 14.9156 16.147 14.866 16.2741C14.8164 16.4012 14.7438 16.5166 14.6524 16.6136C14.5611 16.7106 14.4527 16.7873 14.3336 16.8393C14.2144 16.8913 14.0869 16.9177 13.9582 16.9168H1.84154C1.58313 16.9162 1.33545 16.806 1.15272 16.6104C0.969995 16.4148 0.867095 16.1496 0.866545 15.873V2.90099C0.867095 2.62433 0.969995 2.35917 1.15272 2.16355C1.33545 1.96792 1.58313 1.85775 1.84154 1.85717H10.0624C10.1193 1.85717 10.1756 1.84517 10.2282 1.82185C10.2808 1.79854 10.3286 1.76437 10.3688 1.72129C10.409 1.67821 10.4409 1.62706 10.4627 1.57078C10.4845 1.51449 10.4957 1.45417 10.4957 1.39324C10.4957 1.33232 10.4845 1.27199 10.4627 1.21571C10.4409 1.15942 10.409 1.10828 10.3688 1.0652C10.3286 1.02212 10.2808 0.98795 10.2282 0.964635C10.1756 0.941321 10.1193 0.929321 10.0624 0.929321H1.84154C1.35344 0.9305 0.885647 1.13861 0.540505 1.50811C0.195364 1.87762 0.000978502 2.37843 -0.00012207 2.90099V15.873C0.000978502 16.3955 0.195364 16.8963 0.540505 17.2658C0.885647 17.6353 1.35344 17.8435 1.84154 17.8446H13.9582C14.2005 17.8452 14.4405 17.7947 14.6646 17.6959C14.8886 17.5971 15.0923 17.452 15.2639 17.2689C15.4355 17.0857 15.5717 16.8682 15.6648 16.6287C15.7578 16.3892 15.8059 16.1324 15.8061 15.873Z" fill="white" />
                          <path d="M5.65482 9.45158C5.54455 9.56471 5.46284 9.7059 5.41732 9.86198L4.55273 12.9622L7.4569 12.0455C7.60243 11.9993 7.73491 11.915 7.84232 11.8002L14.9257 4.228L12.7277 1.87939L5.65482 9.45158Z" fill="white" />
                          <path d="M16.6673 1.65865C16.668 1.33066 16.5776 1.00985 16.4077 0.736946C16.2378 0.464042 15.9959 0.251353 15.7128 0.125882C15.4298 0.000410205 15.1183 -0.0321846 14.8179 0.0322352C14.5175 0.096655 14.2417 0.255184 14.0257 0.487696L13.334 1.22373L15.5277 3.5701L16.2152 2.83407C16.3598 2.68016 16.4742 2.49694 16.5519 2.29511C16.6295 2.09329 16.6687 1.87691 16.6673 1.65865Z" fill="white" />
                        </svg>
                      </span>
                    }
                    </div>
                </div>
                {/* InGameNamePopUP */}
              </>
             
            </div>
          </div>
        </div>

          <div className="tournament-joining-popup-step2 mt-4 mb-4">
            <div className="tournament-joining-popup-entryfee">
              <div className="tournament-joining-popup-entryfee-text">
                {t("private-scrims.hosted_by")}
              </div>
              <div className="">
                {contest?.hostedByName}
              </div>
            </div>
            <hr className="tournament-joining-popup-divider" />
            <div className="tournament-joining-popup-entryfee">
              <div className="tournament-joining-popup-entryfee-text">
                {t("private-scrims.date")}
              </div>
              <div className="">
                {moment(contest?.date).format('DD/MM/YYYY')}, {moment(contest?.time).format('h:mm a')}
              </div>
            </div>
          </div>
        </div>
        <button className="submit-button" onClick={handleSave} disabled={isDisableJoinBtn} >{t("contest.join_contest")}</button>
      </div>
    </Popup>
  );
};

export default JoiningScrimPopup;
